import type { TradeDesiredGoods } from '../../../features/lottery/types';
import utilsStyles from '../../../styles/modules/utils.module.scss';
import styles from './TradeableList.module.scss';

export interface TradeableListProps {
  tradeGoodsList: TradeDesiredGoods;
}

const TradeableList: React.FC<TradeableListProps> = ({ tradeGoodsList }) => {
  return (
    <div className={`${styles.container} ${utilsStyles.mtSmall}`}>
      <h2 className={`${styles.title} ${utilsStyles.textBold}`}>交換可能な景品</h2>
      <div className={utilsStyles.mtSmall}>
        {tradeGoodsList.labels.map((label) => (
          <div key={label.id} className={`${styles.prizeItem} `}>
            <div className={styles.prizeItemDetail}>
              <span className={styles.prizeLabel}>{label.stagingName} </span>
              <span className={styles.prizeName}>{label.name}</span>
            </div>
            <span className={`${utilsStyles.primaryColor} ${utilsStyles.textBold} ${styles.tradeableInCount}`}>
              {label.tradeableInCount}個
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TradeableList;
